const cabinetOrigin = process.env.VUE_APP_CABINET_ORIGIN.toUpperCase();

export default {
  //login home page
  loginHeader: {
    contactUs: "Contact us",
  },
  loginPage: {
    instructionstitle: "Client Cabinet",
    instructionsLine1:
      "Please log in using your e-mail and the password you created for your Tradeview Account.",
    instructionsLine2: "In the Client Cabinet you will be able to:",
    featureList1: "Check your account summary",
    featureList2: "Access your account history",
    featureList3: "Fund your account",
    featureList4: "Transfer funds between accounts",
    featureList5: "Request a withdrawal from your account",
    pFooter: `The services and products offered by Tradeview ${cabinetOrigin} Ltd. are not being offered within the United States (US) and are not being offered to US Persons, as defined under US law. The information on this website is not directed to residents of any country where FX and/or CFDs trading is restricted or prohibited by local laws or regulations. CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. Between 74% - 89% of retail investors’ accounts lose money when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money. 74-89% of retail CFD accounts lose money. For further information regarding our fees please refer to this`,
    linkFooter: "link.",
    adressOficce: `Tradeview ${cabinetOrigin} Office:`,
    termsAndConditions: "Terms and Conditions",
    privacyPolicy: "Privacy Policy",
    amlPolicy: "AML Policy",
    refundPolicy: "Refund Policy",
    riskDisclosure: "Risk Disclosure",
    complaintsProcedure: "Complaints Procedure",
    cookiePolicy: "Cookie Policy",
    userError:"Incorrect username or password",
    userErrorTwo: "User does not exist",
    changeSuccess:"Change was successful!",
    passNotMatch:"Passwords do not match.",
    passSpecialC:"Password must have at least one special character.",
    passNumber:"Password must have at least one number.",
    passLength:"Length greater than or equal to 6 characters, including numbers and special characters.",
    reviewData:"Please review the data entered",
    valid:"Please enter a valid email/password",
  },
  loginBox: {
    logInGoogle: "Log in with Google",
    logInFacebook: "Log in with Facebook",
    or: "Or",
    email: "Email",
    password: "Password",
    submit: "Access",
    forgot: "Forgot password?",
    doNotAccount: "Don't have an account?",
    signUp: "Sign Up For Live Account",
    tryFreeDemo: "Sign Up For Demo Account",
    liveAccountLink: "https://tradeviewmena.com/es/formIndividual/",
    demoAccountLink: "https://www.tradeviewmena.com/es/open-demo",
  },
  consoleHeader: {
    account: "Account #",
    balance: "Balance",
    equity: "Equity",
    free: "Free Margin",
    margin: "Margin Level",
    status: "Status",
    hello: "Hello",
    logout: "Log out",
    confirm: "Confirm",
    outModal: "Are you sure you want to logout?",
    yes: "Yes",
    not: "Not",
    selectlang: "Select your language"
  },

  // Platforms page
  platforms: {
    title: "Download Platforms",
    accountLive: "Server Live Account",
    accountDemo: "Server Demo Account",
    tradeviewLive: "TradeviewEurope-Live Europe",
    tradeviewDemo: "TradeviewEurope-Demo Europe",
  },

  //History page
  history: {
    title: "History",
    accountActivity: "Account Activity",
    tradingHistory: "Trading History",
  },

  // Withdraw page
  withdraw: {
    title: "Withdraw",
    platform: "Platform",
    sourceAccount: "Source account*",
    method: "Method*",
    currency: "Currency*",
    start: "Submit",
    beneficiary: "*Beneficiary Name",
    details: "Beneficiary Bank Details",
    number: "*Account Number (IBAN if applicable)",
    code: "*Swift/Code Bank",
    reference: "Reference",
    subTitle: "Intermediary Bank Details (If Needed)",
    name: "*Bank Name",
    bank: "Bank Address",
    swift: "Bank SWIFT",
    branch: "Branch Name",
    province: "Province",
    city: "City",
    dialogShow:
      "Error! this platform has no active accounts you cannot continue with the process, try another platform.",
    errorOne: "Error! There cannot be empty fields",
    errorTwo: "Error! The value exceeds your account balance",
    errorThree: "Error! the email is invalid",
    errorFour: "Error! for credit card only numeric character",
    dialogShowTwo: "Request Submited!, Please check your Email",
    dialogShowThree: "Please Contact Tradeview Support",
    tether: "Tether",
    skrill: "Skrill",
    neteller: "Neteller",
    myfatoorah: "Myfatoorah",
    shift: "Crypto Wallet",
    bank_wire: "Bank Wire",
    placeholAlternative1:"Email Account",
    placeholAlternative2:"Account Number",
    placeholAlternative3:"Email Address of Credit Card Account",
    placeholAlternative4:"Credit Card (Last 4 digits)",
    placeholAlternative5:"Crypto wallet HASH",
    ok: "Ok"
  },

  //Account Activity page
  accountActivity:{
      title: 'Account Activity',
      from: '*From',
      to:'*To',
      type:'*Type',
      platform:'*Platform',
      placeholderAccount: 'Trading account',
      account: '*Account',
      get: 'Request',
      row:'Rows for page',
      download:'Download Report',
      back:'Back',
      confirm: 'Confirm',
      close:'Close',
      error: 'Error! There cannot be empty fields',
      errorTwo: 'Error! you must select the field type.',
      activityid: 'Activity ID ',
      platfomr: 'Platform',
      date: 'Date / Time',
      activity: 'Activity',
      profit: 'Profit/Loss',
      nohistory: 'The account has no history yet'
  },

  //tradingHistory
  tradingHistory: {
    title: "Trading History",
    from: "*From",
    to: "*To",
    type: "Type",
    platform: "Platform",
    placeholderAccount: "Trading account",
    account: "*Account",
    get: "Request",
    row: "Rows for page",
    download: "Download Report",
    back: "Back",
    confirm: "Confirm",
    close: "Close",
    error: "Error! There cannot be empty fields",
    errorTwo: "Error! you must select the field type.",
    deal: "Deal",
    entryTime: "Entry Time",
    typr: "Type",
    simbol: "Symbol",
    volume: "Volume",
    entryPrice: "Entry Price",
    sl: "S/L",
    tp: "T/P",
    exitTime: "Exit Time",
    exitPrice: "Exit Price",
    commision: "Commision",
    swap: "Swap",
    profit: "Profit/Loss",
  },

  newLiveAccount: {
    title: "Create New Live Account",
    platform: "*Select a Platform",
    currency: "*Currency",
    account: "Create Account",
    back: "Back",
    congratulation: "Congratulations",
    text: "Your Live Account Application is under review and will be verified shortly. Our operations team will be in contact with you in case we require any further documentation.",
    error: "Error! There cannot be empty fields",
    close: "Close",
  },

  //Transfer page
  transfer: {
    title: "Transfer between your trading accounts",
    subTitle:
      "In order to transfer funds from one Tradeview account to another, fill out the following form.",
    platform: "Platform",
    sourceAcount: "Source account",
    targetAccount: "Target Account",
    sendingAmount: "Sending Amount",
    condition: `By checking the checkbox I understand that I have requested funds to be transferred from one Tradeview ${cabinetOrigin} Ltd. account to another of my own Tradeview ${cabinetOrigin} Ltd. accounts.`,
    condition2: `By checking the checkbox I understand that I have requested funds to be transferred from one Tradeview Financial Markets SAC account to another of my own Tradeview Financial Markets SAC accounts.`,
    start: "Transfer",
    showDialogOne: "Please Contact Tradeview Support",
    showDialogTwo: "Please Contact Tradeview Support",
    submited: "Request Submited!, Please check your Email",
    error: "Error! There cannot be empty fields",
    erroremail: "Error! The email address is incorrect",
    errorcheck: "You must agree to Tradeview policies",
    errorTwo: "Error! Account numbers must be different",
    errorThree: "Error! The amount is not valid",
    errorFour: "Error! The value exceeds your account balance",
  },

  //Accounts
  accounts: {
    warning:
      "Your Demo Account Request is being processed. Final status will be notiﬁed at your email.",
    live: "Live Trading Accounts",
    demo: "Demo Accounts",
    createLive: "+ Create a New Live Account",
    createDemo: "+ Create a New Demo Account",
    noAccountLive: "No Live Account under email",
    noAccountDemo: "No Demo Account under email",
    dialogShowOne: "You currently have no Metatrader 4 demo accounts.",
    dialogShowTwo: "You currently have no Metatrader 5 demo accounts.",
    dialogShowThree: "You currently have no Metatrader 4 live accounts.",
    dialogShowFour: "You currently have no Metatrader 5 live accounts.",
    dialogShowFive:
      "You currently have no Metatrader 4 or Metatrader 5 live accounts.",
    account: "ACCOUNT #",
    balance: "BALANCE",
    equity: "EQUITY",
    margin: "MARGIN LEVEL",
    free: "FREE MARGIN",
    status: "STATUS",
    leverage: "LEVERAGE",
    currency: "CURRENCY",
  },

  //CreateDemoAccounts
  demoAccounts: {
    title: "Create New Demo Account",
    platform: "* Select a Platform",
    type: "* Account Type",
    amount: "* Deposit Amount",
    currency: "* Currency",
    account: "Create Account",
    back: "Back",
    created: "Your Demo Account has been created",
    text: "Please save your credentials before clicking any option or closing this window, these will NOT be sent to your email.",
    login: "Login",
    pass: "Password",
    currencyTwo: "Currency",
    server: "Server",
    data: "TradeviewEurope-Demo Europe",
    download: "Now you're ready to download your trading platform:",
    close: "Close",
    error: "Error! There cannot be empty fields",
    ilc: "iLC",
    xleverage: "xLeverate",
    createDemoAccountError:
      "An error occurred. Please contact Support to get help",
    createDemoAccountSucces: "Your request has been sent"
  },

  //credit card
  credit: {
    title: "Credit cards",
    subTitle: "This section is not yet available",
    subTitleAdd: "Add Funds",
    platform: "Platform",
    trading: "Trading account",
    amount: "* Amount (Min. 100 USD - max. 10.000 USD)",
    currency: "* Currency",
    details: "Credit Card Details",
    expiration: "Expiration date",
    fund: "Fund",
    disclaimer:
      "Payments are only accepted from an account/card registered in your name. Please note that we may request additional documents and/or information for verification purposes.",
    back: "back",
    confirm: "Confirm Deposit",
    textOne: "Are you sure you want to Deposit",
    textTwo: "with your Credit card?",
    cancel: "Cancel",
    confirm: "Confirm",
    deposit: "Deposit",
    ok: "Ok",
    depositUrl: "Redirect to Zotapay",
    errorOne: "Error! Amount (Min. 100 USD - max. 10,000 USD)",
    errorTwo: "Error! There cannot be empty fields",
    errorThree: "Error! Is not a valid security code",
    errorFour: "Error! Is not a valid expiration date",
    errorFive: "Error! Is not a valid card number",
  },

  //Banck Transfer add found Skrill
  addFounds: {
    title: "Add funds",
    platform: "Platform",
    account: "Trading account",
    currency: "Currency",
    range: "Rango",
    amount: "Amount",
    firstname: "Firstname",
    lastname: "Lastname",
    disclaimer:
      "Payments are only accepted from an account/card registered in your name. Please note that we may request additional documents and/or information for verification purposes.",
    fund: "Fund",
    back: "Back",
    redi: "Redirecting",
    redirection: "Redirecting to",
    checkmark: `By checking the box you agree on all Tradeview ${cabinetOrigin} Ltd. policies.`,
    submit: "Submit",
    fundCreditCard: "Fund with Credit Card",
    btnApplePay: "Pay with",
    dob: "Date of Birth",

    alertTitle: "Attention:",
    alertDesc: "if you reside in Iraq, Syria, Lebanon, Yemen, Somalia, or Libya please send payments directly to one of the below crypto wallets to avoid any delays in funds depositing your account:",
    alertNote:"Please send the Hash as well as your account number to the following email"
  },

  //Add Bank Funds
  addBanckFounds: {
    title: "Add funds",
    description: "Please use this information for Incoming Wires:",
    back: "Back",
    headers1: "For USD Deposits",
    rows1Headers1: "Beneficiary Bank:",
    subrows1Headers1: "BMO Harris Bank, N.A",
    rows2Headers1: "Beneficiary Swift:",
    subrows2Headers1: "HATRUS44",
    rows3Headers1: "ABA No:",
    subrows3Headers1: "071000288",
    rows4Headers1: "Reference:",
    subrows4Headers1: "(Your Name + Tradeview Account No.)",
    rows5Headers1: "Account name:",
    subrows5Headers1: `Tradeview ${cabinetOrigin} Limited`,
    rows6Headers1: "Account number:",
    subrows6Headers1: "4243275",
    rows7Headers1: "Bank Address:",
    subrows7Headers1: "111 West Monroe St, Chicago, IL 60690",
    rows8Headers1: "Beneficiary Address:",
    subrows8Headers1: "114/3 The Strand, Gzira, GZR 1027, Malta",
    headers2: "For USD Deposits",
    rows1Header2: "Beneficiary Bank",
    subrows1Header2: "BMO Harris Bank, N.A",
    rows2Header2: "Beneficiary Swift",
    subrows2Header2: "HATRUS44GTM",
    rows3Header2: "Intermediary Bank",
    subrows3Header2: "Deutsche Bank - Frankfurt",
    rows4Header2: "Intermediary Swift",
    subrows4Header2: "DEUTDEFF",
    rows5Header2: "Reference:",
    subrows5Header2: "(Your Name + Tradeview Account No.)",
    rows6Header2: "Account name",
    subrows6Header2: `Tradeview ${cabinetOrigin} Limited`,
    rows7Header2: "Account number",
    subrows7Header2: "300894250262",
    rows8Header2: "Bank Address",
    subrows8Header2: "111 West Monroe St, Chicago, IL 60603",
    rows9Header2: "Beneficiary Address",
    subrows9Header2: "114/3 The Strand, Gzira, GZR 1027, Malta",
    headersSecond: "For GBP, EUR, USD, CHF and JPY Deposits",
    rows1HeadersSecond: "Beneficiary Bank:",
    subrows1HeadersSecond: "The Currency Cloud Limited",
    rows2HeadersSecond: "Beneficiary Swift:",
    subrows2HeadersSecond: "TCCLGB3L",
    rows3HeadersSecond: "IBAN No:",
    subrows3HeadersSecond: "GB62TCCL04140476597833",
    rows4HeadersSecond: "Reference:",
    subrows4HeadersSecond: "210408-56275 + Your Name and Tradeview Account No.",
    rows5HeadersSecond: "Account name:",
    subrows5HeadersSecond: `Tradeview ${cabinetOrigin} Limited`,
    rows6HeadersSecond: "Account Number:",
    subrows6HeadersSecond: "4243275",
    rows7HeadersSecond: "Bank Address:",
    subrows7HeadersSecond:
      "12 Steward Street, The Steward Building, London, E1 6FQ",
    rows8HeadersSecond: "Beneficiary Address:",
    subrows8HeadersSecond: "114/3 The Strand, Gzira, GZR 1027, Malta",
    headersSecond2: "For EUR Deposits",
    rows1HeadersSecond2: "Account Name:",
    subrows1HeadersSecond2: "Tradeview Europe Ltd Clients Fund Account",
    rows2HeadersSecond2: "Currency:",
    subrows2HeadersSecond2: "EUR",
    rows3HeadersSecond2: "IBAN:",
    subrows3HeadersSecond2: "MT95PYMX09014000002061220100001",
    rows4HeadersSecond2: "BIC:",
    subrows4HeadersSecond2: "PYMXMTMT",
    rows5HeadersSecond2: "Reference:",
    subrows5HeadersSecond2: "(Your Name + Tradeview Account No.)",
    rows6HeadersSecond2: "Bank Name:",
    subrows6HeadersSecond2: "The Currency Cloud Limited",
    rows7HeadersSecond2: "Bank Address:",
    subrows7HeadersSecond2:
      "12 Steward Street, The Steward Building, London, E1 6FQ",
    rows8HeadersSecond2: "Beneficiary Address:",
    subrows8HeadersSecond2: "114/3 The Strand, Gzira, GZR 1027, Malta",
  },

  //Banregio
  banregio: {
    deposit: "Deposit MXN",
    accountName: "ACCOUNT NAME:",
    bankaddres: "BANK ADDRESS:",
    phone: "PHONE:",
    pesos: "PESOS ACCOUNT NUMBER:",
    swift: "SWIFT CODE:",
    clabe: "CLABE:",
    accountNameinfo: "TVM capital S.A de C.V",
    bankaddresinfo:
      "Av. Insurgentes Sur #4250, Col. Colinas de San Jerónimo, Monterrey, Nuevo León",
    phoneinfo: "(81) 21-42-64-30",
    pesosinfo: "035-93009-001-6",
    swiftinfo: "RGIOMXMTXXX",
    clabeinfo: "058580359300900162",
  },

  //fidelity
  fidelity: {
    deposit1: "Deposit USD / FIELD 56- INTERMEDIARY BANK",
    deposit2:
      "Deposit USD / FIELD 57- BENEFICIARY BANK - ACCOUNT WITH INSTITUTION",
    deposit3: "Deposit USD / FIELD 59 - BENEFICIARY CUSTOMER",
    bankname: "BANK NAME:",
    bankaddres: "BANK ADDRESS:",
    swift: "SWIFT CODE:",
    routing: "ROUTING NUMBER:",
    banknameinfo: "Deutsche Bank Trust Company Americas",
    bankaddresinfo: "Jersey City, New Jersey",
    swiftinfo: "BKTRUS33XXX",
    routinginfo: "021-001-033",
    accountname: "ACCOUNT NAME:",
    address: "ADDRESS:",
    swiftbic: "SWIFT CODE/BIC:",
    accountnameinfo: "Proven Bank (Cayman) Limited",
    addressinfo: "36A Dr. Roy’s Drive, GT, Grand Cayman, Cayman Islands",
    swiftbicinfo: "FIYCKYKYXXX",
    accountnumber: "ACCOUNT NUMBER:",
    name: "NAME:",
    accountnumberinfo: "2020-4178",
    nameinfo: "Tradeview Ltd",
    addressinfo2:
      "103 S. Church St, 4th Fl, Grand Cayman, Cayman Islands, KY1-1002",
  },

  //Bbva
  bbva: {
    deposit: "Deposit USD",
    beneficiary: "BENEFICIARY NAME:",
    ruc: "RUC:",
    beneficiarybank: "BENEFICIARY BANK NAME:",
    bankaddres: "BANK ADDRESS:",
    swift: "SWIFT CODE:",
    accountn: "ACCOUNT NUMBER:",
    cci: "CCI:",
    beneficiaryinfo: "TV MARKETS SAC",
    rucinfo: "20605189394",
    beneficiarybankinfo: "BBVA",
    bankaddresinfo: "Avenida Republica de Panama 3055, San Isidro. Lima - PERU",
    swiftinfo: "BCONPEPL",
    accountninfo: "0011-0351-0100035781",
    cciinfo: "011-351-000100035781-42",
  },
  //DBS
  dbs: {
    deposit: "Deposit EUR, GBP, USD, JPY, SGD",
    beneficiary: "BENEFICIARY NAME:",
    beneficiaryAccountNumber: "BENEFICIARY ACCOUNT NUMBER:",
    beneficiaryaddres: "BENEFICIARY ADDRESS:",
    swift: "SWIFT:",
    bankname: "BANK NAME:",
    bankaddres: "BANK ADDRESS:",
    beneficiaryinfo: "WTSG Tradeview Ltd",
    beneficiaryAccountNumberinfo: "072-036473-2",
    beneficiaryaddresinfo:
      "#12-01 Capital Tower, 168 Robinson Road, Singapore, 068912",
    swiftinfo: "DBSSSGSG",
    banknameifo: "DBS Bank",
    bankaddresinfo:
      "12 Marina Boulevard, DBS Asia Central, Marina Bay Financial Centre Tower 3, Singapore 018982",
  },

  //Choose bank
  chooseBank: {
    title: "Choose bank",
    method: "FUNDING METHOD",
    processing: "PROCESSING TIME",
    fee: "FEE",
    back: "Back",
    instruction: `Losses can exceed initial amount invested. Third party payments will NOT be accepted. All deposits MUST be from the original account owner. The trading platform's denomination is in USD. Tradeview ${cabinetOrigin} Ltd. reserves the right to bookback/refund any deposits made via Credit Card in lieu of a withdrawal.`,
  },

  //Choose Credit Card
  ChooseCreditCard: {
    title: "Choose Credit Card",
    method: "FUNDING METHOD",
    processing: "PROCESSING TIME",
    fee: "FEE",
    back: "Back",
    messageZotapay: "Zotapay is temporarily unavailable",
    instructionOne: `Tradeview ${cabinetOrigin} Ltd. is always looking to improve our customer's experience. For this reason, we provide our clients with fast and effective funding methods. If needed please`,
    contact: "contact",
    instructionTwo:
      "our support team who will gladly help expedite your request.",
    instructionThree: `Third-party payments will NOT be accepted. All deposits MUST be from the original account owner. The trading platform's denomination is in euros or in USD. Tradeview ${cabinetOrigin} Ltd. reserves the right to book back/refund any deposits made via Credit Card in lieu of a withdrawal.`,
  },

  //Choose alternative methods
  ChooseAlternativeMethods: {
    title: "Choose alternative methods",
    method: "FUNDING METHOD",
    processing: "PROCESSING TIME",
    fee: "FEE",
    back: "Back",
    instructionOne: `Losses can exceed initial amount invested. Third party payments will NOT be accepted. All deposits MUST be from the original account owner. The trading platform's denomination is in USD. Tradeview ${cabinetOrigin} Ltd. reserves the right to bookback/refund any deposits made via Credit Card in lieu of a withdrawal.`,
  },

  //deposit
  deposit: {
    title: "Choose deposit method",
    vendor: "FUNDING METHOD",
    processingCards: "PROCESSING TIME",
    fee: "FEE",
    methodOneMena: "Credit Cards and Apple Pay",
    methodOne: "Credit Cards",
    methodTwo: "Alternative methods",
    methodThree: "Bank transfer",
    textOne: `Tradeview ${cabinetOrigin} Ltd. is always looking to improve our customer's experience. For this reason, we provide our clients with fast and effective funding methods. If needed please`,
    textTwo: " contact ",
    textThree: "our support team who will gladly help expedite your request.",
    textFour: `Third-party payments will NOT be accepted. All deposits MUST be from the original account owner. The trading platform's denomination is in euros or in USD. Tradeview ${cabinetOrigin} Ltd. reserves the right to book back/refund any deposits made via Credit Card in lieu of a withdrawal.`,
    textOneMena: `Tradeview Financial Markets SAC is always looking to improve our customer's experience. For this reason, we provide our clients with fast and effective funding methods. If needed please`,
    textFourMena: `Third-party payments will NOT be accepted. All deposits MUST be from the original account owner. The trading platform's denomination is in euros or in USD. Tradeview Financial Markets SAC reserves the right to book back/refund any deposits made via Credit Card in lieu of a withdrawal.`,
  },

  //Email
  email: {
    title: "Email settings",
    subTitle:
      "Manage your subscriptions here. Select the topics you would like to receive branded newsletters from:",
    company: "Company news",
    selectOne: "Trading news (",
    selectTwo: "Surf's Up!",
    selectThree: "newsletter)",
    update: "Update",
    instructions:
      "If you no longer want to receive emails on any of the above topics, just uncheck them. Do not forget to click update.",
    confirm: "confirm",
    submitted: "Request Submitted!",
    close: "Close",
  },

  //password
  password: {
    title: "Change Password",
    subTitle:
      "To change your password please request a one-time code to your email account.",
    request: "Request Code",
    submit: "Submit",
    code: "Code",
    current: "Current password",
    confirm: "Confirm new password",
    repeat: "Repeat password",
    save: "Save changes",
    success: "Success",
    confirm: "Confirm",
    close: "Close",
    dialogMessage: "A one-time code was sent to your registered email.",
    dialogMessageOne: "Please type the current password",
    dialogMessageTwo: "Please specify a new password",
    dialogMessageThree: "Please confirm the new password",
    dialogMessageFour: "New/confirm passwords don't match",
  },

  //Contact
  contact:{
      title: 'Request a call',
      firstname: 'YOUR FIRST NAME*',
      lastname: 'YOUR LAST NAME*',
      phone: 'YOUR TELEPHONE NUMBER*',
      email: 'YOUR EMAIL*',
      lenguage: 'SUPPORT LANGUAGE*',
      call: 'PREFERRED TIME TO CALL',
      check: 'Call me as soon as possible',
      contactme:'Contact me',
      error: 'Error! There cannot be empty fields',
      close: 'Close',
      request: 'Request Submited! Please check you email'
  },

  menu: {
    appli: "Applications",
    account: "Accounts",
    platforms: "Platforms",
    history: "History",
    deposit: "Deposit",
    transfer: "Transfer",
    withdraw: "Withdraw",
    settings: "Settings",
    passwordsettings: "Password settings",
    emailsettings: "Email settings",
    authenticationsettings: "Authentication settings",
    contactUs: "Contact us",
  },

  //register
  register: {
    title: "Account Registration",
    create: "Create your login",
    createdes: "Enter your email and choose a password to get started",
    complete: "Complete your application",
    completedes: "Complete our fast and secure application form",
    confirm: "Confirm your ID",
    confirmdes:
      "Verify your identity online or upload your ID documents if required",
    fund: "Fund and trade",
    funddes:
      "Once approved, fund your account using our flexible, low-cost funding methods and start trading",
    goBack: "Go back",
    getYour: "Get your Free Live Account now!",
    instantly: "Instantly register:",
    registerGoogle: "Register with Google",
    registerFacebook: "Register with Facebook",
    or: "OR",
    email: "*EMAIL ADDRESS",
    secure: "*SECURE CLIENT PASSWORD",
    length:
      "(Length greater than or equal to 6 characters, including numbers and special characters)",
    confirmPassword: "*CONFIRM PASSWORD",
    disclaimer: "DISCLAIMER:",
    disclaimerdes1: " Before opening an account it is our obligation at ",
    disclaimerdes2:
      " to ensure that You or the person/s appointed to trade on your behalf have the necessary knowledge and experience in CFD and related financial instruments. It is also our requirement to comply with AML and CFT obligations. In this regard you are kindly requested to provide accurate, complete and factual information as requested in line with this application and in order for us to complete compliance with the above obligations. On the basis of this information we are able to properly determine whether the investment services in connection with the financial instrument/s is/are appropriate to You. All Sections need to be completed. For further details please refer to our ",
    clientAgree: "Client Agreement.",
    byTicking: "*BY TICKING THIS YOU AGREE TO THE ABOVE",
    wish: "*I WISH TO BE THE FIRST TO KNOW ABOUT TRADING SETUP ALERTS, PRODUCTS, NEWSLETTERS, AND SPECIAL OFFERS",
    policity: "(PRIVACY POLICY)",
    getstarted: "Get started",
    messageFooter1: "The services and products offered by ",
    messageFooter2:
      " are not being offered within the United States (US) and not being offered to US persons, as defined under US law. The information on this website is not directed to residents of any country where FX and/or CFDs trading is restricted or prohibited by local laws or regulations. CFDs are complex instruments and come with a high risk of losing funds rapidly due to leverage. Between 74% - 89% of retail investors' accounts lose funds when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of financial loss.",
    youcan: "You can use your ",
    freeDemo: "Free Demo Account ",
    desYouCan:
      "with all of our trading platforms including desktop and mobile for iOS and Android and also access to",
    client: "Client Cabinet",
    desYouCan2: ", our web-based account management portal.",
    practice: "Practice",
    practicedes: "Trade virtual currency in a simulated account",
    learn: "Learn our Tools and Services",
    learndes: "Become familiar with the software platforms",
    titleTwo: "Almost there! Select your account type and",
    titleTwob: "provide some basic information",
    name: "*FIRST NAME",
    lastName: "*LAST NAME",
    register: "Register",
    errorOne: "Please fill all required fields.",
    errorTwo: "Passwords do not match.",
    errorThree: "Password must have at least one special character.",
    errorFour: "Password must have at least one number.",
    errorFive: "Length greater than or equal to 6 characters, including numbers and special characters.",
    errorSix: "Please enter a valid email and password.",
    errorSeven: "Missing fields",
    errorEight:"ERROR: unable to update the application record",
    login: "Login",
    ok:"OK",
    chenge: "Change",
    yes:"Yes",
    sendCode:"Send new code",
    submit: "Submit",
    accountRe: "Account Registration | ",
    description: "Register your account, you are just 4 steps away from creating a new account",
    codeDialog: "Please enter the activation code that was sent to your email.",
    codeDialogTwo: "Make sure to check your spam/junk folders.",
    newCode: "A new code was sent to your email. Please enter the activation code.",
    tryEgain: "Please try again later",
    registering:"Success! Please continue registering",
    instructions:"Check your email for instructions",
    mfaCode:"Insert the MFA Code:",
    code:"Code",
    newPass:"New Password",
    repeatPass:"Repeat Password",
    changePass:"Change Password"

  },

  //Calendar
  calendar: {
    title: "Calendar",
  },
  //application process
  application: {
    pending:
      "Your individual account Request is being processed. Final status will be notified at your email.",
    active: "YOU ALREADY HAVE A LIVE ACCOUNT",
    details: "APPLICATION PROCESS",
    reject: "Application not approved. contact back office",
    tradeviewmena: "Application form not yet enabled for this country",
  },
  //MFA
  mfa: {
    title: "Authentication settings",
    subTitle: "This section is not yet available",
    enable: "Enable 2-step authentication",
    body: "In addition to your password, set up a secondary verification method to keep your account even safer.",
    text: "When you enable 2-step authentication, you will need to enter your password as well as a verification code sent to your email address.",
    turn: "Turn",
    on: "On",
    off: "Off",
    confirm: "Confirm",
    textTwo: "Are you sure you want to disable the MFA?",
    yes: "Yes",
    no: "No",
    qr: "Please scan the QR",
    type: "Type the generated code:",
  },
};
